import {cartHeaderStyles} from "@insite/content-library/Widgets/Cart/CartHeader";
import { css } from "styled-components";

cartHeaderStyles.gridItem1 = {
    width: [10, 10, 8, 9, 9],
    css: css`
    padding: 15px 15px 0px 15px;
    `
}

cartHeaderStyles.gridItem2 = {
    width: [2, 2, 4, 3, 3],
    css: css`
    padding: 15px 15px 0px 15px;
    `
}